import { take, race, delay, call, select } from 'redux-saga/effects'

import { KIOSK_STARTED, KIOSK_STOPPED } from '../actions'
import { getEncodedOccurrence, getOrganizationId } from '../selectors'
import { reportSessionHeartbeat, resetSessionDiagnostics, SESSION_HEARTBEAT_MS } from '../kioskDiagnostics'

function* collectSessionContext() {
  return {
    organizationId: yield select(getOrganizationId),
    encodedOccurrence: yield select(getEncodedOccurrence),
  }
}

function* sessionHeartbeatLoop() {
  while (true) {
    yield delay(SESSION_HEARTBEAT_MS)
    const context = yield call(collectSessionContext)
    yield call(reportSessionHeartbeat, context)
  }
}

export default function* sessionDiagnosticsSaga() {
  while (true) {
    yield take(KIOSK_STARTED)
    yield call(resetSessionDiagnostics)

    const context = yield call(collectSessionContext)
    yield call(reportSessionHeartbeat, context)

    yield race([take(KIOSK_STOPPED), call(sessionHeartbeatLoop)])
  }
}
